/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {HTTP_CONFIG as ɵb} from './lib/http-function-token';
export {HttpFunctionService as ɵa} from './lib/http-function.service';